module.exports = __webpack_public_path__ + "static/electricidad-221803ed1ce6fa70e8b06737000c5296.jpg";